<template>
    <div class="container">
        <div class="main-content">
            <router-view></router-view>
            <h1>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Magni, quia.</h1>
            <h2>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Magni, quia.</h2>
            <h3>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Magni, quia.</h3>
            <h4>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Magni, quia.</h4>
            <h5>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Magni, quia.</h5>
            <h6>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Magni, quia.</h6>
            <p><span>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consectetur dignissimos facilis neque
                nesciunt nihil pariatur, quidem temporibus voluptatem voluptatum. Ab alias aut cumque ea incidunt nemo
                odit praesentium quas quasi.</span><span>Amet aspernatur, at beatae cum dignissimos doloremque dolorum
                earum exercitationem, harum iste iusto laboriosam laudantium magni nam natus neque officiis perferendis
                porro quasi qui quis repellendus tempora tenetur voluptate voluptates.</span></p>
            <label>Lorem ipsum dolor sit.</label>

            <br><br>

            <button class="btn btn__primary" type="button" name="button">Button</button>

            <br><br>

            <button class="btn btn__primary btn__primary--login" type="button" name="button">Button</button>

            <br><br>

            <button class="btn btn__primary btn__primary--outline" type="button" name="button">Button</button>

            <br><br>

            <span class="label label--rejected">Rejected</span>
            <span class="label label--expired">Expired</span>
            <span class="label label--paid">Paid</span>
            <span class="label label--accepted">Accepted</span>
            <span class="label label--invalid">Invalid</span>
            <span class="label label--canceled">Canceled</span>

            <br><br>

            <input class="input input__round" type="text" placeholder="placeholder">
            <input class="input input__round input--calendar" type="text" placeholder="placeholder">
            <input class="input input__round input--search" type="text" placeholder="placeholder">
            <input class="input input__round input--dropdown" type="text" placeholder="placeholder">

            <br><br>

            <input class="input input__round input--key" type="text" placeholder="placeholder">
            <input class="input input__round input--user" type="text" placeholder="placeholder">
            <input class="input input__round input--mail" type="text" placeholder="placeholder">
            <input class="input input__round input--users-checked" type="text" placeholder="placeholder">

            <br><br>

            <input class="input input__underline" type="text" placeholder="placeholder">
            <input class="input input__underline input--calendar" type="text" placeholder="placeholder">
            <input class="input input__underline input--search" type="text" placeholder="placeholder">
            <input class="input input__underline input--dropdown" type="text" placeholder="placeholder">

            <br><br>

            <input class="input input__gray" type="text" placeholder="placeholder">
        </div>
    </div>
</template>

<script>
  export default {
    name: 'design',
  }
</script>

<style lang="scss" scoped>
    $primary-color: #1880E1;
    $secondary-color: #41BC3F;
    $primary-color-btn: #5A78FF;

    $primary-gradient: linear-gradient(to right, #1880E2, #29B1CC);
    $primary-gradient-reverse: linear-gradient(to right, #1960bf, #29B1CC);

    $fail-color: #FF5E5E;
    $success-color: #7ED321;
    $warning-color: #F5A623;
    $digital-color: #1880E1;

    $expired-color: #8B572A;

    $black-100: #4A4A4A;
    $black-90: #6B6C6F;
    $black-80: #9B9B9B;


    $white-100: #FFFFFF;
    $white-90: #F9F9FA;
    $white-85: #F6F7F9;
    $white-80: #F2F3F5;
    $white-70: #DFE2E6;
    $white-50: #D8D8D8;

    $font-large: 1em;
    $font-normal: 0.875em;
    $font-medium: 0.8125em;
    $font-small: 0.75em;
    $font-btn: 13.3333px;

    $margin-large: 16px;
    $margin-medium: 12px;
    $margin-decimal: 10px;
    $margin-small: 8px;
    $margin-nano: 4px;
    $padding-btn: 10px 20px;
    $padding-btn-outline: 8px 20px;

    $radius-100: 100em;
    $radius-btn: 18px;
    $radius-default: 6px;
    $radius-small: 4px;
    $radius-none: 0px;

    $shadow-primary: 0 10px 20px rgba(41, 177, 204, 0.30);
    $shadow-secondary: 0 0px 8px rgba(41, 177, 204, 0.75);
    $shadow-card: 0 10px 20px rgba(41, 177, 204, 0.30);
    $shadow-btn: 0 0px 8px rgba(90, 120, 255, 0.75);

    $calendar-icon: '../../assets/calendar.svg';
    $search-icon: '../../assets/search.svg';
    $chevron-icon: '../../assets/chevron-down.svg';
    $eye-icon: '../../assets/chevron-down.svg';
    $key-icon: '../../assets/key.svg';
    $user-icon: '../../assets/user-input.svg';
    $users-checked-icon: '../../assets/users-checked.svg';
    $mail-icon: '../../assets/mail.svg';

    @import url('https://fonts.googleapis.com/css?family=Montserrat');

    * {
        box-sizing: border-box;
    }

    body {
        font-family: 'Montser', Helvetica, Arial, sans-serif;
        color: $black-100;
        font-size: 1em;

        h1 {
            font-size: 2em;
            line-height: 2*1.5em;
            font-weight: 600;
        }

        h2 {
            font-size: 1.75em;
            line-height: 4.4em;
            font-weight: 600;
        }

        h3 {
            font-size: 1.5em;
            line-height: 1.5*1.5em;
            font-weight: 500;
        }

        h4 {
            font-size: 1.375em;
            line-height: 1.375*1.5em;
            font-weight: 600;
        }

        h5 {
            font-size: 1.125em;
            line-height: 1.125*1.5em;
            font-weight: 500;
        }

        h6 {
            font-size: 1em;
            line-height: 1*1.5em;
            font-weight: 400;
        }

        p {
            font-size: 0.875em;
            line-height: 0.875*1.5em;
            font-weight: 300;
        }

        label {
            font-size: 0.8125em;
            line-height: 0.8125*1.5em;
            font-weight: 400;
            color: $black-90;
            display: block;
        }
    }

    .btn {
        padding: $padding-btn;
        font-size: $font-btn;
        font-weight: 600;
        line-height: $font-normal*1.5;
        text-align: center;
        color: $white-90;
        min-width: 175px;
        border: none;
        border-radius: $radius-btn;

        &:hover {
            cursor: pointer;
            box-shadow: $shadow-btn;
            color: $white-100;
            transition: box-shadow .18s ease-in;
        }

        &:focus {
            outline: none !important;
            box-shadow: $shadow-btn;
        }

        &__primary {
            background: $primary-color-btn;

            &:active {
                transition: background .18s ease-out;
                background: $primary-color-btn;
            }

            &--outline {
                padding: $padding-btn-outline;
                border: 2px solid $primary-color;
                background: transparent;
                color: $primary-color;

                &:hover {
                    background: transparent;
                    box-shadow: none;
                    color: $primary-color;
                }
            }

            &--login {

                box-shadow: $shadow-primary;
                width: 100%;

                &:hover {
                    box-shadow: $shadow-primary;
                }
            }
        }
    }

    .label {
        display: inline-block;
        border-radius: $radius-small;
        padding: $margin-nano;
        font-size: $font-small;
        font-weight: 600;
        line-height: $font-small*1.5;
        color: $white-100;
        background: $black-100;
        min-width: 64px;
        text-align: center;

        &--rejected {
            background: $fail-color;
        }

        &--paid {
            background: $digital-color;
        }

        &--accepted {
            background: $success-color;
        }

        &--created {
            background: $black-100;
        }

        &--invalid {
            background: $warning-color;
        }

        &--expired {
            background: $expired-color;
        }

        &--canceled {
            background: $black-90;
        }
    }

    .input {
        font-size: $font-medium;
        line-height: 1.5*$font-medium;
        color: $black-100;

        &:focus {
            outline: none !important;
            transition: border-color .1s ease-in;
            border-color: $primary-color;
        }

        &::placeholder {
            color: $black-80;
        }

        &__round {
            background: $white-100;
            padding: $margin-decimal;
            border-radius: $radius-100;
            border: 1px solid $white-70;
        }

        &__underline {
            background: $white-100;
            padding: $margin-decimal;
            border: none;
            border-bottom: 2px solid $white-50;

        }

        &__gray {
            background: $white-80;
            padding: $margin-decimal;
            border: none;
            border-bottom: 2px solid $white-50;

        }

        &--search {
            background: url($search-icon) no-repeat $margin-large center;
            padding-left: 4*$margin-medium;
        }

        &--mail {
            background: url($mail-icon) no-repeat $margin-large center;
            padding-left: 4*$margin-medium;
        }

        &--user {
            background: url($user-icon) no-repeat $margin-large center;
            padding-left: 4*$margin-medium;
        }


        &--key {
            background: url($key-icon) no-repeat $margin-large center;
            padding-left: 4*$margin-medium;
        }


        &--users-checked {
            background: url($users-checked-icon) no-repeat $margin-large center;
            padding-left: 4*$margin-medium;
        }

        &--calendar {
            background: url($calendar-icon) no-repeat $margin-large center;
            padding-left: 4*$margin-medium;
        }

        &--dropdown {
            background: url($chevron-icon) no-repeat calc(100% - 16px) center;
            padding-right: 3*$margin-medium;
        }
    }
</style>